"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffLogActionModel = instanceOfLiffLogActionModel;
exports.LiffLogActionModelFromJSON = LiffLogActionModelFromJSON;
exports.LiffLogActionModelFromJSONTyped = LiffLogActionModelFromJSONTyped;
exports.LiffLogActionModelToJSON = LiffLogActionModelToJSON;
exports.LiffLogActionModelToJSONTyped = LiffLogActionModelToJSONTyped;
/**
 * Check if a given object implements the LiffLogActionModel interface.
 */
function instanceOfLiffLogActionModel(value) {
    return true;
}
function LiffLogActionModelFromJSON(json) {
    return LiffLogActionModelFromJSONTyped(json, false);
}
function LiffLogActionModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderNo': json['orderNo'] == null ? undefined : json['orderNo'],
        'action': json['action'] == null ? undefined : json['action'],
        'partnerOrgId': json['partnerOrgId'] == null ? undefined : json['partnerOrgId'],
    };
}
function LiffLogActionModelToJSON(json) {
    return LiffLogActionModelToJSONTyped(json, false);
}
function LiffLogActionModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderNo': value['orderNo'],
        'action': value['action'],
        'partnerOrgId': value['partnerOrgId'],
    };
}
